import * as i18n from 'i18n-ts';
import { en } from './messages';

const i18nConfig = {
  en,
  default: en,
};

export const messages = new i18n.I18nResolver(i18nConfig).translation;
